// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pretty .tag[data-v-7ce0ef3f] {\n  opacity: 0.8 !important;\n}\n", ""]);
// Exports
module.exports = exports;
